export const useArticlesPage = async () => {
  const locale = useI18n().locale

  const { data } = await useAsyncData(
    `articles-page-${locale.value}`,
    async () => {
      try {
        const [articlesRes, videocastsRes] = await Promise.all([
          $fetch('/api/v1/contentful/articles', {
            query: { locale: locale.value },
          }),
          $fetch('/api/v1/contentful/videocasts', {
            query: { locale: locale.value },
          }),
        ])

        const articles = articlesRes?.articles ?? []
        const videocasts = videocastsRes?.videocasts ?? []

        const elements = [...articles, ...videocasts].sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        )

        return {
          articles,
          videocasts,
          elements,
        }
      } catch (e) {
        console.error(e)
        return {
          articles: [],
          videocasts: [],
          elements: [],
        }
      }
    },
  )

  return {
    data,
    articles: computed(() => data.value?.articles ?? []),
    videocasts: computed(() => data.value?.videocasts ?? []),
    elements: computed(() => data.value?.elements ?? []),
  }
}
